<template>

  <div :id="layoutId" class="font-sans bg-white text-gray-900">
    <div class="px-[1.5rem] py-[1.25rem] lg:p-[3rem]">
      <HeaderSection
        class="m-auto max-w-[68.5714rem] lg:max-w-[68.5714rem] xl:max-w-[82.2857rem] 2xl:max-w-[96rem]"
        :title="heading"
        :breadcrumbItems="breadcrumbItems"
        :id="`header-${layoutId}`"
        :breadcrumbHeadingTag="breadcrumbHeadingTag"
      />
    </div>
      <hr v-if="showHr" class="border-t border-gray-300 w-full" aria-hidden="true" />
    <div>
      <CategoryNavigation
        :categories="categoryLinks"
        :id="`category-${layoutId}`"
        class="bloglayout-categories m-auto max-w-[68.5714rem] lg:max-w-[68.5714rem] xl:max-w-[82.2857rem] 2xl:max-w-[96rem] text-black"
      />
      <hr class="border-t border-gray-300 w-full" aria-hidden="true" />
    </div>
    <div
      class="bg-[linear-gradient(90deg,_white_50%,_var(--color-gray-50)_100%)]"
    >
      <div
        class="m-auto max-w-[68.5714rem] lg:max-w-[68.5714rem] xl:max-w-[82.2857rem] 2xl:max-w-[96rem] grid grid-cols-1 lg:grid-cols-4"
      >
        <slot></slot>
        <SideBar
          class="lg:col-span-1"
          :trending="trendingData"
          :listen="listenData"
          :faqHelpful="faqHelpfulData"
          :onlyMedia="onlyMediaData"
          :multiMedia="multiMediaData"
          :showTake5DailySidebar="showTake5DailySidebar"
          :showListenElsewhere="showListenElsewhere"
          :showForFaQSidebar="showForFaQSidebar"
          :showFaqSearchTips="showFaqSearchTips"
          :showFaqHelpful="showFaqHelpful"
          :showForNewsroomSidebar="showForNewsroomSidebar"
          :showOnlyNewsroomDetails="showOnlyNewsroomDetails"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {computed} from "vue";
import HeaderSection from "~/components/ui/organism/headerSection.vue";
import CategoryNavigation from "~/components/ui/atom/categoryNavigation.vue";
import SideBar from "~/components/ui/organism/take-five-daily/sideBar.vue";
import { useRoute } from 'vue-router'
import { URL_CONFIG } from "~~/shared/utils/url.const";

withDefaults(
  defineProps<{
    layoutId?: string;
    heading?: string;
    breadcrumbItems?: any[];
    categoryLinks?: any[];
    trendingData?: any[];
    listenData?: any[];
    faqHelpfulData?: any[];
    onlyMediaData?: any[];
    multiMediaData?: any[];
    showListenElsewhere?: boolean;
    showTake5DailySidebar?: boolean;
    showForFaQSidebar?: boolean;
    showFaqSearchTips?: boolean;
    showFaqHelpful?: boolean;
    showForNewsroomSidebar?: boolean;
    showOnlyNewsroomDetails?: boolean;
    breadcrumbHeadingTag?: string;
  }>(),
  {
    layoutId: "blog-layout",
    heading: "",
    breadcrumbItems: () => [],
    categoryLinks: () => [],
    trendingData: () => [],
    listenData: () => [],
    faqHelpfulData: () => [],
    onlyMediaData: () => [],
    multiMediaData: () => [],

    showListenElsewhere: false,
    showTake5DailySidebar: false,
    showForFaQSidebar: false,
    showFaqSearchTips: false,
    showFaqHelpful: false,
    showForNewsroomSidebar: false,
    showOnlyNewsroomDetails: false,
    breadcrumbHeadingTag:""
  }
);

const route = useRoute()
const showHr = computed(() => route?.path === URL_CONFIG.NEWS_ROOM)
</script>
